export default __webpack_public_path__ + "static/checkbox-bf3138387a35218152b3db8703423136.gif";